import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAuthUserLocalStorage } from "../../../services/localStorage/localStorage";
import {
  GetResourceFolders,
  GetSalonResources,
} from "../../../services/resources/resources";
import {
  setIsResourceFoldersLoading,
  setIsResourcesLoading,
  setResourceFolders,
  setResources,
} from "../../../store/slices/resourcesSlice";
import { status } from "../../../utils/constants";
import { toastMessage } from "../../../utils/helper";
import AllResources from "./AllResources";
import ResourceFolders from "./ResourceFolders";

const ResourceBody = (props) => {
  const { currentSalonId, salon, reloadCategories } = useSelector(
    (state) => state.global,
  );
  const dispatch = useDispatch();
  const isSuperAdmin = useSelector(
    ({ auth }) => !!auth?.me?.data?.roles?.find(({ id }) => id === 1),
  );

  const { renderTable, allResourcePagination } = useSelector(
    (state) => state.resources,
  );

  const [deleteData, setDeleteData] = useState(false);
  const fetchIdRef = useRef(0);

  const authUser = GetAuthUserLocalStorage();

  const getSalonFilterParams = () => {
    const technologies = salon?.technologies?.map(({ name }) => name) ?? [];
    const softwares = salon?.softwares?.map(({ name }) => name) ?? [];
    const products = salon?.products?.map(({ product }) => product) ?? [];
    return { technologies, softwares, products };
  };

  const getAllResources = async () => {
    if (!salon?.id && !isSuperAdmin) return;
    const { technologies, softwares, products } = getSalonFilterParams();

    const categoryId =
      props.categoryOverrideRef?.current !== undefined
        ? props.categoryOverrideRef.current
        : props.seletedCategory;
    if (props.categoryOverrideRef) {
      props.categoryOverrideRef.current = undefined;
    }

    const fetchId = ++fetchIdRef.current;
    try {
      dispatch(setIsResourcesLoading(true));
      let params = {
        salon_id: currentSalonId,
        user_id: authUser?.id,
        status: status?.active,
        is_paginated: 1,
        category_id: categoryId,
        page: allResourcePagination.page,
        "per-page": allResourcePagination.perPage,
        softwares,
        technologies,
        products,
      };
      const res = await GetSalonResources(params);
      if (fetchId !== fetchIdRef.current) return;
      dispatch(
        setResources({
          data: res?.data?.data?.data,
          meta: res?.data?.data?.meta,
        }),
      );
    } catch (e) {
      if (fetchId !== fetchIdRef.current) return;
      toastMessage("error", e.message);
    } finally {
      if (fetchId === fetchIdRef.current) {
        dispatch(setIsResourcesLoading(false));
      }
    }
  };

  // Folders always load the full category list — never filter by category
  const getResourceFolders = async () => {
    if (!salon?.id && !isSuperAdmin) return;
    const { technologies, softwares, products } = getSalonFilterParams();
    try {
      dispatch(setIsResourceFoldersLoading(true));
      const params = {
        salon_id: currentSalonId,
        status: status?.active,
        softwares,
        technologies,
        products,
      };
      const res = await GetResourceFolders(params);
      const folders = Array.isArray(res?.data?.data) ? res.data.data : [];
      dispatch(setResourceFolders({ data: folders }));
    } catch (e) {
      toastMessage("error", e.message);
    } finally {
      dispatch(setIsResourceFoldersLoading(false));
    }
  };

  useEffect(() => {
    getAllResources();
    setDeleteData(false);
  }, [
    props.seletedCategory,
    deleteData,
    renderTable,
    JSON.stringify(allResourcePagination),
    currentSalonId,
    salon,
    isSuperAdmin,
  ]);

  useEffect(() => {
    getResourceFolders();
  }, [
    deleteData,
    renderTable,
    currentSalonId,
    salon,
    isSuperAdmin,
    reloadCategories,
  ]);

  return (
    <>
      <div className="content">
        {props.activeTab == "folders" && (
          <ResourceFolders onOpenFolder={props.onOpenFolder} />
        )}

        {props.activeTab == "resources" && (
          <AllResources
            deleteData={deleteData}
            setDeletedData={setDeleteData}
            seletedCategory={props.seletedCategory}
          />
        )}
      </div>
    </>
  );
};

export default ResourceBody;
